import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions} from '@angular/http';

import {AuthService} from './auth.service';
import {ConfigService} from './config.service';
import {LogService} from './log.service';

import * as uuid from 'uuid';


@Injectable()
export class FeedbackService {
	constructor(
		private http: Http,

		private authService: AuthService,
		private config: ConfigService,
		private log: LogService
	) {}

/*
	getFilms() {
		return new Promise( (resolve, reject) => {

			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			let options = new RequestOptions({ headers: headers });

			this.http.get(this.config.basePath + '/v0/films', options)
				.toPromise()
				.then( (res) => {
					let foo = res.json();

					// films.allFilms.films

					// console.log(foo);
					let sortedFilms = foo.allFilms.films.sort((a: any, b: any) => {


						if (a.title.toLowerCase() === b.title.toLowerCase()) {
							return 0;
						}
						if (a.title.toLowerCase() < b.title.toLowerCase()) {
							return -1;
						}
						return 1;

						// if (a.sortSubmissionId === b.sortSubmissionId) {
						// 	return 0;
						// }
						// if (a.sortSubmissionId < b.sortSubmissionId) {
						// 	return -1;
						// }
						// return 1;
					});
					foo.allFilms.films = sortedFilms;
					resolve(foo);
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					// TODO - handle errors?
					this.log.error(err);
				});
		});
	}
*/



	sendFeedback(feedback: any) {
		return new Promise( (resolve, reject) => {
			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			headers.append('Content-Type', 'application/json');
			let options = new RequestOptions({ headers: headers });

			let userId = this.authService.userId;
			let payload = {
				feedbackId: uuid.v4().replace(/-/g, ''),
				feedbackUserId: userId,
				feedback: feedback
			};
			let body = JSON.stringify(payload);

			this.http.post(this.config.basePath + '/v0/feedbacks', body, options)
				.toPromise()
				.then( (res) => {
					// let foo = res.json();

					// console.log(foo);
					// let bar: any = foo;
					resolve();
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					this.log.error(err);
					reject();
				});
		});
	}





	getFeedbacks() {
		return new Promise( (resolve, reject) => {
			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			let options = new RequestOptions({ headers: headers });

			this.http.get(this.config.basePath + '/v0/feedbacks', options)
				.toPromise()
				.then((res: any) => {
					resolve(res.json());
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					console.log(err);
					// resolve({});			// TODO - reject with error !!!
				});
		});



/*
		return $q(function(resolve, reject) {

			$http.get(apiHost + '/v0/feedbacks')
			.success(function(data, status, headers, config) {
// console.log('here I am at getFeedbacks #3');
// console.log('data');
// console.log(data);
				return resolve(data);
			})
			.error(function(data, status, headers, config) {
//						console.log('got here #f29');
//console.log('here I am at getLogs #4');

				// Log.warn('Could not get log list from api.');		// avoid endless loop
				console.log('Could not get feedback list from api.');

				return resolve(null);
			});

		});
*/



	}





/*



		return {
			sendFeedback: function(userId, feedback) {
//				console.log('<------ sendFeedback -------->');
				return $q(function(resolve, reject) {
					var payload = {
						feedbackId: uuid.v4().replace(/-/g, ''),
						feedbackUserId: userId,
						feedback: feedback
					};

					$http.post(apiHost + '/v0/feedbacks', payload)
					.success(function(data, status, headers, config) {
//						console.log('got here #f28');

						return resolve(true);
					})
					.error(function(data, status, headers, config) {
//						console.log('got here #f29');

						Log.warn('Could not send feedback to api.');
						return resolve(null);
					});

				});
			},





			getFeedbacks: function () {
				return $q(function(resolve, reject) {

					$http.get(apiHost + '/v0/feedbacks')
					.success(function(data, status, headers, config) {
// console.log('here I am at getFeedbacks #3');
// console.log('data');
// console.log(data);
						return resolve(data);
					})
					.error(function(data, status, headers, config) {
//						console.log('got here #f29');
//console.log('here I am at getLogs #4');

						// Log.warn('Could not get log list from api.');		// avoid endless loop
						console.log('Could not get feedback list from api.');

						return resolve(null);
					});

				});

			}




*/



}



// WEBPACK FOOTER //
// /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/feedback.service.ts